// extracted by mini-css-extract-plugin
export default {"in-row-as-of-date":"investment-facts_in-row-as-of-date__Y2XUv"};